import '../assets/css/bookingDetail.less';
import React from 'react';
import { getEnv } from '../utils';
import { recordIsEnterLiveRoom } from '../api/request';
import { message, Button } from 'antd';

export const BOOKING_WAY = {
    100529221: '电话',
    100529222: '直播',
    100529223: '面授',
    PHONE: 100529221,
    LIVE: 100529222,
    FACE2FACE: 100529223,
};

export const FLAG_CONFIG = {
    CLASSNAME: 'classRoom',
    PLAYBACK: 'playback'
};

export const BOOKING_SCENE = {
    homePage: 1, // 学习系统首页
    liveCourse: 2, // 直播课 
    videoCourse: 3, // 视频课
    ep3StudyPlan: 4, // ep3 学习计划
    glive2StudyPlan: 5, // glive2学习计划
    ep3StudyReport: 6, // ep3学习报告
    glive2StudyReport: 7, // glive2 学习报告
    note: 8, // 笔记
    smartAnswer: 9, // 智能答疑
    personAnswer: 10, // 人工答疑
    selfLive: 11, // 私教直播
    selfFunction: 12, // 私教预约功能
    selfPhone: 13// 私教电话
};

//过滤预约状态0:待上课1:待评价2:已结束3:已取消
const filterBookingType = (item) => {
    let type = item.status;
    switch (item.status) {
        case 0:
            type = 0;
            break;
        case 1:
            if (item.isLike) {
                type = 2;
            }

            break;
        case 2:
            if (!item.isLike) {
                type = 1;
            }
            break;
        case 3:
            break;
        case 4:
            type = 3;
            break;
        default:
            return 0;

    }
    return type;

};

/**
 * @description 进入教室 | 查看回放跳转
 * @param {*} type 功能类型
 * @param {*} data 详情数据
 */
export const handleJumpUrl = (type, {
    customerId,
    enterStudioUuid,
    enterStudioPath,
    enterPlaybackPath
}) => {
    if (type === FLAG_CONFIG.CLASSNAME) {
        recordIsEnterLiveRoom({
            processId: customerId,
            uuid: enterStudioUuid
        }).then(res => {
            res.data.result && window.open(enterStudioPath);
        });
    } else {
        enterPlaybackPath && window.open(enterPlaybackPath);
    }
};


//反馈报告
export const handelFeedBack = ({ customerId, commit }) => {
    if (!(1 == commit)) {
        message.warning('请耐心等待老师提交反馈');
        return;
    }
    window.open(`https://${getEnv()}v.gaodun.com/tutor/feedback?processId=${customerId}`);
};

export const initImgUrl = (bookingDetailInfo) => {
    const fileListArr = [];
    const memberImage = bookingDetailInfo.memberImage;

    if (memberImage) {
        const imageListArr = memberImage.split(',');
        imageListArr.forEach((item, key) => {
            let obj = {
                uid: key,
                url: item.includes('http') ? item : 'https://' + getEnv() + 'simg01.gaodunwangxiao.com/' + item,
                name: item.split('/').pop()
            };
            fileListArr.push(obj);
        });
    }
    return fileListArr;
};

/** 获取上课信息  评价的*/
export const renderServiceDegreeEvaluation = (bookingDetail) => {
    const bookingType = filterBookingType(bookingDetail);
    return (
        <>
            <div className="detail-divider" />
            <div className="detail-title">我的预约服务</div>
            <div className="detail-form">
                <div className="detail-row clear">
                    <div className="row-left fl"><span>上课科目：</span><span className="detail-content">{bookingDetail.subjectName}</span></div>
                    <div className="row-right fl"><span>上课时间：</span><span className="detail-content">{bookingDetail.timeRange}</span></div>
                </div>
                <div className="detail-row clear">
                    <div className="row-left fl"><span>手机号码：</span><span className="detail-content">{bookingDetail.reserveMobile}</span></div>
                    <div className="row-right fl"><span>上课方式：</span><span className="detail-content">{BOOKING_WAY[bookingDetail.serviceType]}</span></div>
                </div>
            </div>
        </>
    );
};


/** 获取上课信息 isEvaluation true 课程评价月面 */
export const renderServiceDegreeComp = (bookingDetail, isEvaluation) => {
    const imageList = initImgUrl(bookingDetail);
    const bookingType = filterBookingType(bookingDetail);
    if (isEvaluation) {
        return renderServiceDegreeEvaluation(bookingDetail);
    }

    return (
        <div>
            <div className="detail-divider" />
            <div className="detail-title">我的预约服务</div>
            <div className="detail-form">
                <div className="detail-row clear">
                    <div className="row-left fl"><span>当前状态：</span><span className="detail-status">{
                        (bookingType === 0 && bookingDetail.isEnterStudio === 0) ? '上课中' : (bookingType === 0 ? '待上课' : '已结束')}</span></div>
                    <div className="row-right fl"><span>提交时间：</span><span className="detail-content">{bookingDetail.createTime}</span></div>
                </div>

                <div className="detail-row clear">
                    <div className="row-left fl"><span>上课科目：</span><span className="detail-content">{bookingDetail.subjectName}</span></div>
                    <div className="row-right fl"><span>手机号码：</span><span className="detail-content">{bookingDetail.reserveMobile}</span></div>
                </div>
                <div className="detail-row class-way clear">
                    <div className="row-left fl">
                        <span>上课方式：</span>
                        <span className="detail-content">{BOOKING_WAY[bookingDetail.serviceType]}</span>&emsp;
                        {/* 待上课 */}
                        {(bookingType === 0 && BOOKING_WAY[bookingDetail.serviceType] === '直播'
                            ? (
                                <Button
                                    disabled={bookingDetail.isEnterStudio === 0 ? false : true}
                                    onClick={() => handleJumpUrl(FLAG_CONFIG.CLASSNAME, bookingDetail)}
                                    size="small"
                                    type="primary"
                                >进入教室</Button>
                            )
                            : null)}
                        {/* 待评价 */}
                        {((bookingType === 2 || bookingType === 1) && bookingDetail.supportReport == 1
                            ? (
                                <Button
                                    className={bookingDetail.commit ? 'activeColor' : ''}
                                    disabled={bookingDetail.commit ? false : true}
                                    onClick={() => handelFeedBack(bookingDetail)}
                                    shape="round"
                                    size="small"
                                    style={{ marginRight: '10px' }}
                                >反馈报告</Button>
                            )
                            : null)}
                        {((bookingType === 2 || bookingType === 1) && BOOKING_WAY[bookingDetail.serviceType] === '直播' && bookingDetail.isSupportPlayback == 1
                            ? (
                                <Button
                                    className={bookingDetail.isPlayback ? 'activeColor' : ''}
                                    disabled={bookingDetail.isPlayback ? false : true}
                                    onClick={() => handleJumpUrl(FLAG_CONFIG.PLAYBACK, bookingDetail)}
                                    shape="round"
                                    size="small"
                                >{bookingDetail.isPlayback ? '查看回放' : '暂无回放'}</Button>
                            )
                            : null)}

                    </div>
                    <div className="row-right fl"><span>上课时间：</span><span className="detail-content">{bookingDetail.timeRange}</span></div>
                </div>
            </div>
            {
                bookingDetail.evaluationPath ? (
                    <div className="evaluationReport">
                        本次私教服务，老师将根据您此次测评遇到的问题来解答&ensp;
                        <a
                            className="gd-green"
                            href={bookingDetail.evaluationPath}
                            rel="noopener noreferrer"
                            target="_blank"
                        >测评报告</a>
                    </div>
                ) : null
            }
            {/* 根据是否有测评判断测评*/}
            {!bookingDetail.evaluationPath && (
                <div className="detail-form">
                    <strong>我的提问</strong>
                    <div className="detail-row clear">
                        <div className="row-label fl">问题描述：</div>
                        <div className="row-content fl">{bookingDetail.description}</div>
                    </div>
                    <ul className="img-group">
                        {
                            imageList.length > 0 && imageList.map((image, key) => (
                                <img
                                    alt="question"
                                    key={key}
                                    src={image.url} />
                            ))
                        }
                    </ul>
                </div>
            )
            }
        </div>
    );
};
